import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoSummaryAdapter} from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';
import {TagDataService} from './tagData.service';
import {TagSummaryModel} from "../../../api/model/tagSummary.model";
import {TagSummaryConverter} from "../../../api/model/tagSummary.converter";
import {TagModel} from "../../../api/model/tag.model";


@Injectable({providedIn: 'root'})
export class TagSummaryDataServiceAdapter extends AbstractDataServiceDtoSummaryAdapter<
    TagSummaryModel,
    TagSummaryConverter,
    TagModel> {
    constructor(dataService: TagDataService, converter: TagSummaryConverter) {
        super(dataService, converter);
    }
    newStoredEntityInstance(): TagModel {
        return new TagModel();
    }
}
